module.exports = __webpack_public_path__ + "img/account-dollar-square.1aa3c77b.svg";